// Previous / today / next buttons plus a date picker (SPEC §7.2). "Today" is the school's today (SPEC §8.4).

import { addDays } from "../dates";
import { formatLongDate, t } from "../i18n/i18n";
import { requireSchool } from "../session";
import { createButton, createElement } from "./dom";

/** Navigation by a step of days (1 for days, 7 for weeks). */
export function buildDateNavigator(date: string, stepDays: number, onChange: (date: string) => void): HTMLElement {
  const wrapper: HTMLDivElement = createElement("div", "toolbar");
  const picker: HTMLInputElement = createElement("input");
  picker.type = "date";
  picker.value = date;
  picker.setAttribute("aria-label", t("app.date"));
  picker.addEventListener("change", (): void => {
    if (picker.value !== "") {
      onChange(picker.value);
    }
  });
  wrapper.append(
    createButton("← " + t("app.previous"), (): void => {
      onChange(addDays(date, -stepDays));
    }),
    createButton(stepDays === 7 ? t("app.thisWeek") : t("app.today"), (): void => {
      onChange(requireSchool().today);
    }),
    createButton(t("app.next") + " →", (): void => {
      onChange(addDays(date, stepDays));
    }),
    picker,
    createElement("strong", "", formatLongDate(date)),
  );
  return wrapper;
}
